module.exports = __webpack_public_path__ + "images/icon/document-f6280e3a.svg";